<!-- HEADER -->
<app-header
  [class.show-background]="showToolbar"
  color="transparent"
  class="header-override"></app-header>

<!-- CONTENT -->
<ion-content
  class="padded"
  [scrollEvents]="true"
  (ionScroll)="onScroll($event)">
  <!-- HERO -->
  <ng-container *ngIf="hero; else featuredImage">
    <app-hero [node]="hero"></app-hero>
  </ng-container>
  <ng-template #featuredImage>
    <div class="hero">
      <app-img-format
        *ngIf="data?.featuredImage"
        [src]="data?.featuredImage"
        [alt]="data?.title"
        [disableLazyLoad]="true"
        [aspectRatio]="data.featuredImageRatio"></app-img-format>
      <ion-text
        [color]="data?.fontShade && data?.fontShade === 'dark' ? 'primary' : 'light'">
        <h1 class="hero-title">{{data?.title | uppercase}}</h1>
      </ion-text>
    </div>
  </ng-template>

  <!--Header Explore -->
  <ng-container *ngIf="explore">
    <app-explore [node]="explore"></app-explore>
  </ng-container>

  <!-- EVENTS -->
  <section
    *ngIf="data?.featuredItems?.events && data?.featuredItems?.events.length > 0"
    class="events">
    <ion-text color="dark" class="ion-text-center">
      <h2 class="related-content-title">Events</h2>
    </ion-text>

    <!-- FEATURED -->
    <app-feature
      *ngIf="(data.featuredItems?.events.length === 1 || data.featuredItems?.events.length > 2)"
      [data]="data.featuredItems?.events[0]"
      type="default"
      [showType]="true"
      [hideCategory]="true"
      class="floating"
      [class.single-event]="data.featuredItems?.events.length === 1"></app-feature>

    <!-- LISTING GRID -->
    <ion-grid
      *ngIf="data.featuredItems?.events.length > 1"
      class="event-listing">
      <ion-row>
        <ion-col
          size="12"
          [sizeMd]="columnSize"
          *ngFor="let event of data.featuredItems?.events | slice:startIndex">
          <app-card
            [data]="event"
            class="card-boxed"
            [img]="{ url: event.featuredImage, alt: event.title ,aspectRatio: '16:9' }"
            [showType]="true"
            [hideCategory]="true"></app-card>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div
      class="ion-no-padding ion-flex ion-justify-content-center ion-margin-top">
      <app-button
        href="/events"
        type="secondary"
        [icon]="{ name: 'arrow-right', position: 'right' }">
        View all Events
      </app-button>
    </div>
  </section>

  <!-- BLOGS -->
  <section
    *ngIf="data?.featuredItems?.blogs && data?.featuredItems?.blogs.length > 0"
    class="blogs">
    <ion-text color="dark" class="ion-text-center">
      <h2 class="ion-hide-md-down related-content-title">Blogs</h2>
      <h2 class="ion-hide-md-up related-content-title">Featured Blog</h2>
    </ion-text>

    <!-- FEATURE BLOCK -->
    <ng-container
      *ngFor="let item of data?.featuredItems?.blogs | slice:0:1; let i = index">
      <app-feature
        [data]="item"
        [index]="i"
        type="default"
        class="floating"></app-feature>
    </ng-container>

    <!-- LISTING GRID -->
    <ion-grid class="ion-hide-md-down card-grid">
      <ion-row>
        <ng-container
          *ngFor="let item of data?.featuredItems?.blogs | slice:1:4; let i = index">
          <ion-col size="12" size-md="4">
            <app-card
              [data]="item"
              class="card-boxed"
              [img]="{ url: item.featuredImage, alt: item.title, aspectRatio:'16:9' }"></app-card>
          </ion-col>
        </ng-container>
        <ion-col
          size="12"
          class="ion-hide-md-down ion-flex ion-justify-content-center ion-no-padding ion-padding-end ion-padding-bottom ion-text-end">
          <app-button
            href="/blogs"
            type="secondary"
            [icon]="{ name: 'arrow-right', position: 'right' }">
            View all Blogs
          </app-button>
        </ion-col>
      </ion-row>
    </ion-grid>

    <h2 class="ion-hide-md-up related-content-title">Latest Blogs</h2>
    <ion-slides pager="true" [options]="slideOpts" class="ion-hide-md-up">
      <ion-slide
        *ngFor="let item of data?.featuredItems?.blogs | slice:1:4; let i = index"
        class="ion-align-items-start ion-justify-content-start">
        <app-card
          [data]="item"
          class="card-boxed"
          [showType]="true"
          [img]="{ url: item.featuredImage, alt: item.title, aspectRatio:'16:9' }"
          [hidePrice]="true"></app-card>
      </ion-slide>
    </ion-slides>
  </section>

  <!-- COMPETITION -->
  <section
    *ngIf="data?.featuredItems?.competitions && data?.featuredItems?.competitions.length > 0"
    class="competitions ion-padding-bottom">
    <ion-text color="dark" class="ion-text-center">
      <h2 class="related-content-title">Competitions</h2>
    </ion-text>

    <!-- FEATURE BLOCK -->
    <ng-container
      *ngFor="let item of data?.featuredItems?.competitions | slice:0:1; let i = index">
      <app-feature
        [data]="item"
        [index]="i"
        type="competition"
        [showType]="true"
        [hideCategory]="true"
        class="floating"></app-feature>
    </ng-container>

    <div
      class="ion-text-center ion-flex ion-justify-content-center ion-text-md-end ion-padding-end ion-padding-vertical">
      <app-button
        href="/competitions"
        type="secondary"
        [icon]="{ name: 'arrow-right', position: 'right' }">
        View all Competitions
      </app-button>
    </div>
  </section>

  <!-- OFFERS -->
  <section
    *ngIf="data?.featuredItems?.offers && data?.featuredItems?.offers.length > 0"
    class="offers">
    <section>
      <div class="related-content ion-content-stretched swiper-stretched">
        <ion-text color="dark" class="ion-text-center">
          <h2 class="related-content-title">Latest Offers</h2>
        </ion-text>
        <ion-slides pager="true" [options]="slideOpts">
          <ion-slide
            *ngFor="let item of data?.featuredItems?.offers"
            class="ion-align-items-start ion-justify-content-start">
            <app-card
              [data]="item"
              class="card-boxed card-boxed-mobile"
              [showType]="true"
              [img]="{ url: item.featuredImage, alt: item.title, aspectRatio:'16:9' }"
              [hidePrice]="true"></app-card>
          </ion-slide>
        </ion-slides>
        <div
          class="ion-text-center ion-flex ion-justify-content-center ion-text-md-end ion-padding-end ion-padding-top">
          <app-button
            href="/offers"
            type="secondary"
            [icon]="{ name: 'arrow-right', position: 'right' }">
            View all Offers
          </app-button>
        </div>
      </div>
    </section>
  </section>

  <!-- BODY -->
  <app-dynamic-html *ngIf="data?.body" [data]="data?.body"></app-dynamic-html>

  <!-- MOVIES -->
  <section *ngIf="nowShowing && nowShowing.length > 0" class="movies">
    <div class="related-content ion-content-stretched swiper-stretched">
      <ion-text color="dark" class="ion-text-center">
        <h2 class="related-content-title">
          NOW BOOKING AT {{ environment.environment_name === "rosebank" ?
          "Cinema Nouveau" : cinemaProvider.name }}
        </h2>
      </ion-text>
      <ion-slides pager="true" [options]="slideOptsMovies">
        <ion-slide
          *ngFor="let item of nowShowing"
          class="ion-align-items-start ion-justify-content-start">
          <app-movie-card [movie]="item"></app-movie-card>
        </ion-slide>
      </ion-slides>

      <div
        class="ion-hide-md-down ion-flex ion-justify-content-center ion-text-end ion-padding-end">
        <app-button
          href="/movies"
          type="secondary"
          [icon]="{ name: 'arrow-right', position: 'right' }">
          View all Movies
        </app-button>
      </div>
    </div>
  </section>

  <app-footer></app-footer>
</ion-content>
